import isoCountries from 'i18n-iso-countries';
import english from 'i18n-iso-countries/langs/en.json';
import german from 'i18n-iso-countries/langs/de.json';
import french from 'i18n-iso-countries/langs/fr.json';
import spanish from 'i18n-iso-countries/langs/es.json';
import italian from 'i18n-iso-countries/langs/it.json';
import dutch from 'i18n-iso-countries/langs/nl.json';
import {
  getLocalePrefix,
} from '@/integrations/crystallize/language-and-market';

// Initialize English locale for countries translations, TODO other languages
isoCountries.registerLocale(english);
isoCountries.registerLocale(german);
isoCountries.registerLocale(french);
isoCountries.registerLocale(spanish);
isoCountries.registerLocale(italian);
isoCountries.registerLocale(dutch);

// removes the webhierarchy* prefix from crystallize content paths
export function removePathPrefix(path: string): string {
  return path.replace(/(\/(webhierarchy\w*)(\/|$))/, '/');
}

// Mirrors the middleware's langCountryRegex so client-side prefix stripping agrees with the
// server: locale-less deep links (e.g. /invite/x) are rewritten, not redirected, so the first
// path segment must be verified as a locale before it is dropped.
const localePrefixRegex = /^([a-z]{2})(?:-([a-z]{2}|001))?$/i;

export function getPathWithoutLocalePrefix(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  const remaining = localePrefixRegex.test(segments[0] ?? '') ? segments.slice(1) : segments;

  return remaining.join('/');
}

export function removeOverviewPagePath(path: string): string {
  if (path.endsWith(`/${process.env.NEXT_PUBLIC_CRYSTALLIZE_FOLDER_OVERVIEW_NAME}`)) {
    return path.slice(0, -`/${process.env.NEXT_PUBLIC_CRYSTALLIZE_FOLDER_OVERVIEW_NAME}`.length);
  }
  return path;
}

export function isPathExternalLink(path: string): boolean {
  return path.startsWith('http');
}

export function buildLocaleLink(path: string, language: string, country: string): string {
  return `/${getLocalePrefix(language, country)}${path}`;
}

export function getLocaleLink(path: string, language: string, country: string) {
  return buildLocaleLink(removePathPrefix(path), language, country);
}

// Checks if the current path matches the given exact path, ignoring the localization prefix.
export function pathMatchIgnoreLocale(currentPath: string, matchPath: string) {
  const pathSegments = currentPath.split('/').filter(Boolean);
  const normalizedPath =
    pathSegments.length > 1 ? `/${pathSegments.slice(1).join('/')}` : currentPath;

  return normalizedPath === matchPath;
}

// helperf funciton to map country code to existing one
export function mapCountryCode(countryCode: string) {
  switch (countryCode) {
    case 'uk':
      return 'gb';
    default:
      return countryCode;
  }
}

export function getCountryName(countryCode: string, language: string): string {
  const code = mapCountryCode(countryCode);
  return isoCountries.getName(code, language) || code;
}

export function getAllCountries(language: string) {
  return isoCountries.getNames(language, { select: 'official' });
}

export function getLanguageName(languageCode: string) {
  const displayNames = new Intl.DisplayNames([languageCode], { type: 'language' });
  const displayName = displayNames.of(languageCode);
  return displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : null;
}

export function constructAreaCode(countryCode: string, area: string): string {
  return `${countryCode}/${area}`;
}
